import { WorkflowEditorService } from 'api-clients/monolith';
import { useApiService } from 'hooks';
import React from 'react';
import { useParams } from 'react-router-dom';

export function useRulesTargetOpenings({
  externalId,
  filterToSelectedOnly,
}: {
  externalId: string;
  filterToSelectedOnly?: boolean;
}) {
  const { funnelSlug } = useParams<{ funnelSlug?: string }>();
  const fetchRulesTargetOpenings = React.useCallback(
    () =>
      WorkflowEditorService.getInternalApiWorkflowEditorRulesEditData(
        externalId,
        funnelSlug,
        filterToSelectedOnly,
        true,
      ),
    [externalId, filterToSelectedOnly, funnelSlug],
  );

  return useApiService(fetchRulesTargetOpenings);
}
